import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-update-page',
  templateUrl: './update-page.component.html',
  styleUrls: ['./update-page.component.css']
})
export class UpdatePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/page/update/update-page.component.ts